module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-slash-7576f415.svg";